import React from 'react';
import { useIntl } from 'react-intl';
import { BeneficiariesContent } from '../../components/organims/BeneficiariesContent';

export const NaturalBeneficiaries = () => {
  const { messages: intlMessages } = useIntl();

  return <BeneficiariesContent contactType="natural" emptyContentMessage={intlMessages['beneficiaries.naturalEmptyContentMessage']} />;
};
